import React, { useContext, useEffect } from 'react';
import Header from './Header';
import HeaderMenu from '../features/builder/components/HeaderMenu';
import ComponentMenu from '../features/builder/components/ComponentMenu';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import useLockedState from '../features/session/useLockedState';
import { useTrackingUsers } from '../features/session/useTrackingUsers';
import { StateContext } from '../App';
import orderBy from 'lodash/orderBy';

const EditorTemplate = ({ children, context }) => {
  const { lockedState } = useLockedState();

  const state = useContext(StateContext);
  const currentState = state.history[state.history.length - 1];

  const { isReleasing, userMoved } = useTrackingUsers();
  useEffect(() => {
    userMoved();
  }, [window.location.pathname]);

  return (
    <div className='builder-flex builder-flex-1 builder-flex-col builder-h-screen builder-font-body builder-text-sm'>
      {/*HEADER*/}
      <Header renderMenu={() => <HeaderMenu isReleasing={isReleasing} />} />
      <DndProvider backend={HTML5Backend}>
        <div className='builder-relative builder-flex builder-flex-1 '>
          <div className=' builder-flex builder-flex-1 builder-h-full builder-relative' style={{ backgroundColor: '#dee2ec' }}>
            <div className={`builder-flex builder-w-full builder-flex-1 `}>
              <ComponentMenu customBlocks={orderBy(currentState.customBlocks, 'description')} context={context} />
              <div className={`builder-relative ${lockedState ? 'builder-pointer-events-none' : ''}`}>
                {lockedState && <div className='builder-absolute builder-inset-0 builder-z-9999 builder-bg-white builder-opacity-50 builder-h-full'> </div>}
                {children}
              </div>
            </div>
          </div>
        </div>
      </DndProvider>
    </div>
  );
};

export default EditorTemplate;
